// @flow
import * as React from 'react'
import styled from 'styled-components'
import Flex from 'ui/atoms/Flex'
import SemiBoldText from 'ui/atoms/SemiBoldText'
import Text from 'ui/atoms/Text'
import Theme from 'ui/theme'

import ModalCloseButton from './ModalCloseButton'

type Props = {
  title?: string,
  closeButton?: boolean,
  onHide?: () => void,
  subtitle?: string,
}

const BlueHeader = styled.div`
  background-color: ${Theme.color.main};
  min-height: 60px;
  padding: ${Theme.spacing.regular};
  border-radius: 0.3rem 0.3rem 0 0;
  margin: -1.5rem -1.5rem ${Theme.spacing.regular};
`

const ModalBlueHeader = ({
  title,
  closeButton,
  onHide,
  subtitle,
}: Props): React.Node => (
  <BlueHeader>
    <Flex justify="between">
      <div>
        <SemiBoldText>{title}</SemiBoldText>
        {subtitle && <Text $light>{subtitle}</Text>}
      </div>
      {closeButton && <ModalCloseButton onHide={onHide} />}
    </Flex>
  </BlueHeader>
)

export default ModalBlueHeader
